<template>
  <div class="show-more-button" :class="{ 'show-more-button--up': isMore }" @click="changeStatus">
    <span>{{ $t(isMore ? '收起' : '查看更多') }}</span>
    <i class="iconfont icon-xiangxia"></i>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'isMore',
    event: 'change'
  },
  props: {
    isMore: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    changeStatus() {
      this.$emit('change', !this.isMore)
    }
  }
}
</script>

<style lang="scss" scoped>
.show-more-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
  font-size: 12px;
  color: var(--font-color-3);
  .iconfont {
    margin-left: 5px;
    font-size: 12px;
  }
}
.show-more-button--up {
  .iconfont {
    transform: rotate(180deg);
  }
}
</style>
